module.exports = __webpack_public_path__ + "static/media/payment.068c5c7a.svg";